import { h5Css, Link } from '@atlassian/amkt-common';
import { LinkUtils, UrlUtils } from '@atlassian/mpac-utils';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import SolutionsPropTypes from '../../../../app/components/Routes/components/CategoriesRoutes/constants/SolutionsPropTypes';
import CommonPropTypes from '../../../../app/constants/PropTypes';
import LinkRecord from '../../../records/Link';
import NamedLink from '../../../records/NamedLink';
import { helpLinks, mediaLinks } from '../constants/linkGroups';
import NamedLinksFooterSection from './NamedLinksFooterSection';
import SubscribeToMailingList from './SubscribeToMailingList';

import styles from './Footer.less';

export const MediaLinksHeading = styled.div`
  ${h5Css}
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 20px;
  text-transform: uppercase;
`;

export default class Footer extends Component {
  static propTypes = {
    history: CommonPropTypes.history,
    collectionsConfig: CommonPropTypes.collectionsConfig.isRequired,
    onSubscribeToMailingListClicked: PropTypes.func.isRequired,
    solutionsConfig: CommonPropTypes.solutionsConfig.isRequired,
    solutionsMetadata: CommonPropTypes.asyncData(SolutionsPropTypes.categoriesMetadata).isRequired,
  };

  namedCollectionLinks = () => {
    return this.props.solutionsMetadata
      .get('data')
      .filter(categoryPage => categoryPage.includeInFooter)
      .map(
        s =>
          new NamedLink({
            name: s.name,
            link: new LinkRecord({
              href: UrlUtils.resolveUrlFromTemplateAndParameters({
                template: this.props.solutionsConfig.links.solution.href,
                parameters: { category: s.key },
              }),
            }),
          })
      )
      .merge(this.props.collectionsConfig.links.collections.map(c => c.link))
      .sortBy(c => c.name);
  };

  render() {
    return (
      <ScreenClassRender render={this.renderFooter}>
        <span />
      </ScreenClassRender>
    );
  }

  renderFooter = sc => {
    const largeScreen = sc === 'lg' || sc === 'xl';
    return largeScreen ? (
      <div className={styles.footerContent}>
        <div className={styles.footerContentInner}>
          <div className={styles.footerSectionContainer}>
            {this.props.solutionsMetadata.get('data') ? (
              <NamedLinksFooterSection
                heading="Collections"
                namedLinks={this.namedCollectionLinks()}
                onLinkClick={this.onCollectionLinkClick}
              />
            ) : null}
          </div>
          <div className={styles.footerSectionContainer}>
            <NamedLinksFooterSection
              heading="Help"
              namedLinks={helpLinks}
              openLinksInNewWindow={true}
            />
          </div>
          <div className={styles.footerSectionContainer}>
            <SubscribeToMailingList
              onSubscribeClicked={this.props.onSubscribeToMailingListClicked}
            />
            <div className={styles.mediaLinksContainer}>
              <MediaLinksHeading>Follow</MediaLinksHeading>
              {mediaLinks.map(link => {
                return (
                  <Link
                    className={styles.mediaLink}
                    href={link.link.href}
                    key={link.key}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img src={link.image} alt={link.key} />
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  };

  onCollectionLinkClick = (e, namedLink) => {
    if (this.props.history) {
      LinkUtils.maybeOpenInNewTab(e, () => {
        this.props.history.push({ pathname: namedLink.link.href });
      });
    }
  };
}
